import React from "react";
import { Typography } from "@mui/material";
import BaseModal from "components/BaseModal";
import * as Styled from "../../styles";

interface CancelProviderModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mode: "ADD" | "EDIT";
}

function CancelProviderModal({
  open,
  onClose,
  onConfirm,
  mode,
}: CancelProviderModalProps) {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      cancellationText="Não quero cancelar"
      confirmationText="Sim, desejo cancelar"
      cancellationCallback={onClose}
      confirmationCallback={onConfirm}
      title="Cancelar"
    >
      <Typography>Você tem certeza que deseja cancelar?</Typography>
      <Styled.ImportantNotice>
        <Styled.InfoIconStyled />
        <Styled.InfoTypography variant="body2">
          <Styled.ImportantLabel>Importante: </Styled.ImportantLabel>
          Os dados {mode === "EDIT" ? "editados" : "inseridos"}
          {" não serão salvos e nem "}
          {mode === "EDIT" ? "atualizados" : "adicionados"} ao Provedor.
        </Styled.InfoTypography>
      </Styled.ImportantNotice>
    </BaseModal>
  );
}

export default CancelProviderModal;
